import React from "react";
import { Card, Container } from "react-bootstrap";
import Ticket from "./Ticket";
import {Row, Col} from "react-bootstrap";

function CardMisCodigos({
  correo,
  titulo,
  fecha,
  tickets = [],
  numeroAleatorio = [],
  numerosPremiados = [],
}) {
  // Normalizar lista de premios a un Set de strings para comparaciones rápidas
  const premiosSet = new Set(
    Array.isArray(numerosPremiados) ? numerosPremiados.map((n) => String(n).trim()) : []
  );
  return (
    <Container className="mt-4">
      <Card className="mb-4 shadow-sm">
        <Card.Body>
        <Card.Subtitle className="mb-2 text-muted">Dinamicas:</Card.Subtitle>
        <h5>{titulo || "No disponible"}</h5>

        <Card.Subtitle className="mb-2 text-muted">Correo:</Card.Subtitle>
        <h6>{correo}</h6>

        <Card.Subtitle className="mb-2 text-muted">
          Fecha de la dinamica:
        </Card.Subtitle>
        <h6>{fecha || "No disponible"}</h6>

        <Card.Subtitle className="mb-2 text-muted">
          Tickets bendecidos:
        </Card.Subtitle>
        <Row className="g-0 gy-2 justify-content-center">
          {tickets.length > 0 ? (
            tickets.map((num, index) => (
              <Col className="tight-col" xs={3} sm={2} md={2} lg={1} key={index}>
                <Ticket numeroTicket={num} esPremiado={premiosSet.has(String(num).trim())} />
              </Col>
            ))
          ) : (
            <p>No tienes tickets disponibles.</p>
          )}
        </Row>
        </Card.Body>
      </Card>
    </Container>
  );
}

export default CardMisCodigos;
